import type { MyReview, PublicReview } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { formatDate } from '@/shared/lib';
import { StarRating } from './star-rating';

interface ReviewCardProps {
  readonly review: PublicReview | MyReview;
  readonly onOpenImage?: (index: number) => void;
}

export const ReviewCard = ({ review, onOpenImage }: ReviewCardProps): ReactElement => {
  const purchase = [
    review.colorName,
    review.printMethodName,
    `${review.quantity.toLocaleString('ko-KR')}개 구매`,
  ]
    .filter((part) => part !== null)
    .join(' · ');
  return (
    <article className="border-b border-border py-6">
      <div className="flex items-center gap-3 text-sm">
        <StarRating value={review.rating} size="sm" />
        {'authorName' in review && <span className="font-medium">{review.authorName}</span>}
        <span className="text-muted-foreground">{formatDate(review.createdAt)}</span>
        {review.isEdited && <span className="text-muted-foreground">수정됨</span>}
      </div>
      <p className="mt-1 text-xs text-muted-foreground">{purchase}</p>
      <p className="mt-3 whitespace-pre-line text-sm leading-relaxed">{review.content}</p>
      {review.images.length > 0 && (
        <ul className="mt-4 flex gap-2">
          {review.images.map((image, index) => (
            <li key={image.id}>
              <button
                type="button"
                aria-label={`후기 사진 ${index + 1} 크게 보기`}
                onClick={() => onOpenImage?.(index)}
                className="block size-20 overflow-hidden bg-muted"
              >
                <img src={image.url} alt="" className="size-full object-cover" />
              </button>
            </li>
          ))}
        </ul>
      )}
    </article>
  );
};
